export default "__VITE_ASSET__CDYMbceW__"